import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectNewbuildingBrokerConsultantBannerUrl } from 'shared/selectors/newbuildingBrokerConsultantBanner';

import { NewbuildingBrokerConsultantCarouselBanner } from './NewbuildingBrokerConsultantCarouselBanner';

interface INewbuildingBrokerConsultantCarouselBannerContainerProps {
  onClick(): void;
}
export function NewbuildingBrokerConsultantCarouselBannerContainer({
  onClick,
}: INewbuildingBrokerConsultantCarouselBannerContainerProps) {
  const url = useSelector(selectNewbuildingBrokerConsultantBannerUrl) as string;

  return <NewbuildingBrokerConsultantCarouselBanner onClick={onClick} url={url} />;
}
